export const testTypes = [
  {
    value: 'Antigen',
    manufacturers: [
      { value: 'Access Bio, Inc.' },
      { value: 'Becton, Dickinson and Company (BD)' },
    ],
  },
  {
    value: 'PCR',
    manufacturers: [{ value: 'Quidel' }, { value: 'Thermofischer' }],
  },
  {
    value: 'Molecular',
    manufacturers: [{ value: 'Quidel' }, { value: 'Thermofischer' }],
  },
  {
    value: 'Antibody',
    manufacturers: [
      { value: 'Healgen Scientific' },
      { value: 'Assure Tech. (Hangzhou Co., Ltd)' },
    ],
  },
]
  